import { IDashboardMeta } from '../../types';

export const meta: IDashboardMeta = {
  componentName: 'basstrakk-map',
  // TBD
  exampleImgUrl: '#',
  nickname: 'basstrakk-map',
  pageList: [
    'https://staging.bassmaster.com/basstrakk/tournaments/2018-bassmaster-classic-bracket',
  ],
  renderId: 'react-app--basstrakk-map',
};
